/* unplugin-vue-components disabled */import { render } from "./SideMenu.vue?vue&type=template&id=97ca0bde&scoped=true&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=97ca0bde&scoped=true&lang=css"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy (2)\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ca0bde"]])

export default __exports__